import { render, staticRenderFns } from "./select-widget.vue?vue&type=template&id=6881e3ac&scoped=true"
import script from "./select-widget.vue?vue&type=script&lang=js"
export * from "./select-widget.vue?vue&type=script&lang=js"
import style0 from "./select-widget.vue?vue&type=style&index=0&id=6881e3ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6881e3ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6881e3ac')) {
      api.createRecord('6881e3ac', component.options)
    } else {
      api.reload('6881e3ac', component.options)
    }
    module.hot.accept("./select-widget.vue?vue&type=template&id=6881e3ac&scoped=true", function () {
      api.rerender('6881e3ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/select-widget.vue"
export default component.exports